import { useCallback } from 'react';

import { checkCurrentUser, updateCurrentUser, useSaveDataRequest } from '@futrli/shared-services';

type RequestDataType = Awaited<ReturnType<typeof checkCurrentUser>>;

/**
 * Loads the current user data
 */
export const useSaveUserData = () => {
  const { save: saveData, ...rest } = useSaveDataRequest<RequestDataType>();

  const save = useCallback(
    async (newData: Partial<RequestDataType>) => {
      return saveData(updateCurrentUser(newData as Record<string, string>));
    },
    [saveData]
  );

  return {
    save,
    ...rest
  };
};
